// extracted by mini-css-extract-plugin
module.exports = {"video":"da51a739f7--video--Hd320","video__title":"da51a739f7--video__title--coDqn"};